// ── Company Mission V2 ──

import Icons from "components/Icons";

export const findOptionByValue = (options, value) =>
  options.find((o) => o.value === value) || null;

export const MISSION_TYPE = {
  STEP: { label: "ก้าว", value: "step", icon: <Icons.Shoe color="#002366" /> },
  EXERCISE: { label: "ขยับร่างกาย", value: "mission_move", icon: <Icons.Dumbell color="#002366" /> },
  EYE_RELAX: { label: "ผ่อนคลายสายตา", value: "mission_eye", icon: <Icons.EmojiSleep color="#002366" /> },
};

export const COMPETITION_FORMAT = {
  DEPARTMENT: { label: "แบบแผนก", value: "department", icon: <Icons.Building3 color="#002366" /> },
  TEAM: { label: "แบบแบ่งทีม", value: "team", icon: <Icons.PeopleGroup color="#002366" /> },
};

export const MISSION_STATUS = {
  PENDING: { label: "รอเริ่มภารกิจ", value: "pending" },
  REGISTRATION: { label: "ช่วงลงทะเบียน", value: "registration" },
  ACTIVE: { label: "เริ่มภารกิจแล้ว", value: "active" },
  EXPIRED: { label: "สิ้นสุดภารกิจ", value: "expired" },
};

export const MISSION_GOAL = {
  SHARED_GOAL: { label: "เป้าหมายร่วมกัน", value: "shared_goal" },
  FIRST_COMPLETE: {
    label: "เป้าหมายทำให้สำเร็จก่อน",
    value: "first_to_complete",
  },
  HIGHEST_SCORE: { label: "คะแนนรวมสูงสุด", value: "highest_score" },
};


export const missionTypeFilterOptions = [
  MISSION_TYPE.STEP,
  MISSION_TYPE.EXERCISE,
  MISSION_TYPE.EYE_RELAX,
];

export const competitionFormatFilterOptions = [
  COMPETITION_FORMAT.DEPARTMENT,
  COMPETITION_FORMAT.TEAM,
];

export const missionGoalOptions = [
  MISSION_GOAL.SHARED_GOAL,
  MISSION_GOAL.FIRST_COMPLETE,
  MISSION_GOAL.HIGHEST_SCORE,
];

export const missionStatusFilterOptionsTabActive = [
  MISSION_STATUS.PENDING,
  MISSION_STATUS.REGISTRATION,
  MISSION_STATUS.ACTIVE,
];

export const missionStatusFilterOptionsHistory = [
  MISSION_STATUS.EXPIRED,
];

export const perPageOptions = [
  { label: "20", value: 20 },
  { label: "50", value: 50 },
];